import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-042893e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-600 mt-1 text-base"
}
const _hoisted_2 = {
  key: 1,
  class: "station-connector text-sm"
}
const _hoisted_3 = { class: "station" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-dot" }, null, -1))
const _hoisted_5 = { class: "flex justify-content-between w-full text-base" }
const _hoisted_6 = { class: "font-semibold" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-connector-line" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "station"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "station-dot" }, null, -1))
const _hoisted_11 = { class: "flex justify-content-between w-full text-base" }
const _hoisted_12 = { class: "font-semibold" }
const _hoisted_13 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.leg.agencyRoute)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.leg.agencyRoute.longName) + " • " + _toDisplayString(_ctx.leg.agencyRoute.agency), 1))
      : _createCommentVNode("", true),
    (_ctx.leg.start.station)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.leg.start.station.name), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatTime(_ctx.leg.startTime)), 1)
            ])
          ]),
          _hoisted_8,
          (_ctx.leg.end.station)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.leg.end.station.name), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatTime(_ctx.leg.endTime)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}